import http from '@/util/http-common'

class SettingsDataService {
    getAll() {
        return http.get('/mobileStatus')
    }

    getDevices(data) {
        return http.post('/Device/GetAll', data)
    }

    getAllFtpConfig() {
        return http.get('/Configurations')
    }

    createFtpConfig(data) {
        return http.post('/Configurations', data)
    }

    updateFtpConfig(data) {
        return http.patch(`/Configurations/${data.id}`, data)
    }

    deleteFtpConfig(id) {
        return http.delete(`/Configurations/${id}`)
    }

    create(data) {
        return http.post('/mobileStatus/Message', data)
    }

    update(data) {
        return http.patch('/mobileStatus/Message', data)
    }

    delete(id) {
        return http.delete(`/mobileStatus/Message/${id}`)
    }

    getAppVersions() {
        return http.get('/Device/APKVersions')
    }

    uploadApk(data) {
        return http.post('/Device/UploadAPK', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    updateRequiredVersion(data) {
        return http.post('/Device/UpdateRequiredVersion', data)
    }

    updateRequiredVersionBulk(data) {
        return http.post('/Device/UpdateRequiredVersionBulk', data)
    }

    updateRequiredDownload(data) {
        return http.post('/Device/UpdateRequiredDownload', data)
    }

    updateDeviceFtpConfigurations(data) {
        return http.post('/Device/UpdateDeviceFtpConfigurations', data)
    }

    settingsGetAll() {
        return http.get('/Setting')
    }

    addSettings(data) {
        return http.post('/Setting', data)
    }

    updateSettings(data) {
        return http.patch(`/Setting/${data.id}`, data)
    }

    deleteSettings(id) {
        return http.delete(`/Setting/${id}`)
    }

    getServerUrls() {
        return http.get('/Setting/GetServerUrls')
    }

    updateCurrentServerUrl(data) {
        return http.post('/Device/UpdateCurrentServerUrl', data)
    }

    updateDeviceConfigurations(data) {
        return http.post('/Device/BulkUpdateDeviceConfigurations', data)
    }

    getDbConnectionStrings() {
        return http.get('/Setting/GetDbConnectionStrings')
    }

    migrateData(data) {
        return http.post('/Setting/MigrateData', data)
    }

    deviceLogs(data) {
        return http.post('/DeviceLogs/GetAll', data)
    }
}

export default new SettingsDataService()
